import { useMemo } from 'react';

import { DefaultTooltip, Badge } from 'twyne-new.ui'

import { NameAndCreateDateFormatter, HeaderRPUImpresisonsFormatter, RPUFormatter, getInfo } from '@Components/Grid/components/Table/formatters'
import column, { defaultColumn, defaultActionsColumn, deleteAction, duplicateWithNameAction, editAction, defaultColumnId, defaultActiveColumn } from '@Components/Grid/utils/column';

export default function useColumns() {
  return useMemo(() => [
    defaultColumnId(),
    defaultColumn('name', 'Description', info => <NameAndCreateDateFormatter info={info} />, { size: 300 }),
    column.accessor('pages.length', {
      cell: info => info.getValue() || 'N/A',
      header: 'Active Pages',
      enableSorting: false,
    }),
    column.accessor('', {
      header: 'TCPA Configuration',
      cell: info => <HasTCPAFormatter info={info} />,
    }),
    column.accessor('impressions', {
      header: () => <HeaderRPUImpresisonsFormatter title='Impressions' />,
      cell: info => info.getValue() || 0,
      enableSorting: false,
    }),
    column.accessor('rpu', {
      header: () => <HeaderRPUImpresisonsFormatter title='RPU' />,
      cell: info => <RPUFormatter info={info} />,
      enableSorting: false,
    }),
    defaultActiveColumn(),
    defaultActionsColumn(editAction, deleteAction, duplicateWithNameAction),
  ], [])
}

function HasTCPAFormatter({ info }) {
  const { row } = getInfo(info)
  const { integration_data } = row
  const integrationData = JSON.parse(integration_data) || {}
  const tcpaEnabled = integrationData.tcpaEnabled === undefined ? !!integrationData.twyurl : integrationData.tcpaEnabled

  const config = {
    true: { color: 'accent', text: 'active' },
    false: { color: 'danger', text: 'inactive' },
  }

  const toolTipContent = tcpaEnabled ? <div>
    {`URL:  ${integrationData.twyurl}`}<br />
    {`PID:  ${integrationData.pid}`} &nbsp; &#8226; &nbsp; {`SID:  ${integrationData.sid}`}
  </div> : null

  return <DefaultTooltip content={toolTipContent}>
    <Badge variant='outline' color={config[tcpaEnabled].color}>
      {config[tcpaEnabled].text}
    </Badge>
  </DefaultTooltip>
}
